module.exports = __webpack_public_path__ + "fonts/6f87593.otf";